import { api } from '../../../lib/api';

// Sistema (ciclo-panel, R5): el JSON que deja el recolector del VPS por cron.
// Los tipos siguen a `vps/tablero_vps.py::armar_datos` del repo hermano.

export type Veredicto = 'ok' | 'mal' | 'sin_dato';

export interface SistemaItem {
  clave: string;
  tipo: 'contenedor' | 'workflow' | 'servicio' | 'puerto' | 'instancia_wa';
  nombre: string;
  que_hace: string;
  esperado: string;
  puertos?: string;
  trampa?: string;
  real: string | null;
  veredicto: Veredicto;
  detalle: string;
}

export interface SistemaLinea {
  id: string;
  nombre: string;
  color: string;
  descripcion: string;
  doc?: string;
  items: SistemaItem[];
  n_ok: number;
  n_mal: number;
  n_sin_dato: number;
  salud: Veredicto;
}

export interface SistemaExposicion {
  puerto: string;
  proto: 'tcp' | 'udp';
  proceso: string;
  interfaz: 'todas' | 'local' | 'privada';
  docker: boolean;
  capas: string;
  nivel: 'expuesto' | 'una_capa' | 'ok';
  esperado_publico: boolean;
  sondeo: string;
}

export interface SistemaAviso {
  nivel: 'alto' | 'medio' | 'bajo';
  texto: string;
  linea: string;
}

export interface SistemaDatos {
  host: string;
  ip: string | null;
  tomado: string;
  kpis: {
    contenedores: [number, number];
    workflows: [number, number];
    disco_pct: number | null;
    disco: string;
    ram: string;
    load: string;
    uptime_d: number;
    leads: number | null;
    leads_24h: number | null;
    leads_7d: number | null;
    backup_dias: number | null;
    publicos: number;
    una_capa: number;
    expuestos: number;
  };
  lineas: SistemaLinea[];
  exposicion: SistemaExposicion[];
  avisos: SistemaAviso[];
  externos: { id: string; nombre: string; detalle: string; usado_por: string[] }[];
  flujos: { de: string; a: string; etiqueta?: string }[];
  capas: { nombre: string; estado: 'ok' | 'parcial' | 'falta'; detalle: string }[];
  umbral_disco: number;
}

export interface SistemaRespuesta {
  disponible: boolean;
  tomadoEn: string | null;
  tomadoHaceMin: number | null;
  datos: SistemaDatos | null;
  motivo?: string;
}

export const sistemaApi = {
  async obtener(): Promise<SistemaRespuesta> {
    const { data } = await api.get<SistemaRespuesta>('/admin/sistema');
    return data;
  },
};
